(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-backup"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  /* ── Generate colors from color names ── */
  function generateColorHex(colorName) {
    /* Fallback intelligent color generation based on name */
    const colorMap = {
      black: '#111',
      white: '#e0e0e0',
      blue: '#3b5bdb',
      red: '#e03131',
      green: '#2d9e6b',
      gold: '#d4a017',
      silver: '#c0c0c0',
      purple: '#7c3aed',
      pink: '#e64980',
      yellow: '#fab005',
      gray: '#808080',
      grey: '#808080',
      brown: '#8b4513',
      navy: '#000080',
      teal: '#008080',
      olive: '#808000',
    };
    return colorMap[colorName.toLowerCase()] || '#888';
  }

  /* ── Dynamically set CSS variables ── */
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.documentElement;
    const colorSwatches = document.querySelectorAll('.grest-color-swatch');

    colorSwatches.forEach((swatch) => {
      const colorName = swatch.querySelector('span:last-child').textContent;
      const varName = '--color-' + colorName.toLowerCase().replace(/\s+/g, '-');
      if (!getComputedStyle(root).getPropertyValue(varName).trim()) {
        root.style.setProperty(varName, generateColorHex(colorName));
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
